export default {
    title: 'Company Values',
    description:
        "Define the core values that represent your organization's culture and guiding principles.",
    addValue: 'Add Value',
    maxValuesReached: 'Maximum of 8 company values allowed.',
    noValues: 'No company values defined yet.',
    moreOptions: 'More options',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    editValue: 'Edit Value',
    modalSubtitle: 'Define a core value that represents your organization',
    detailsTab: 'Details',
    questionsTab: 'Evaluation Questions',
    translationsTab: 'Translations',
    comingSoon: 'Coming soon',
    nameLabel: 'Value Name',
    namePlaceholder: 'e.g., Integrity, Innovation, Customer Focus',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Describe what this value means to your organization...',
    iconLabel: 'Icon',
    iconPlaceholder: 'e.g., heart, star, shield',
    iconSearchPlaceholder: 'Search icons by name...',
    iconsAvailable: '{{count}} icons available',
    noIconFound: 'No icon found for "{{query}}"',
    chooseIcon: 'Choose an icon',
    iconBackgroundLabel: 'Icon Background',
    iconBackgroundPlaceholder: 'e.g., #0DD3C3 or linear-gradient(...)',
    backgroundColorLabel: 'Background Color',
    resetToIconColor: 'Reset to icon color',
    backgroundColorHint:
        'Choose a main color to generate a gradient. The icon remains independent.',
    customColor: 'Custom color',
    cancel: 'Cancel',
    save: 'Save',
    add: 'Add',
    errorLoadingValues: 'Error loading company values',
    confirmDelete: 'Are you sure you want to delete this value?',
    saveSuccess: 'Company value saved successfully.',
    saveError: 'Failed to save company value.',
    deleteSuccess: 'Company value deleted.',
    nameDuplicateError: 'A company value with this name already exists.',
    nameRequired: 'Value name is required.',
    // Value Questions
    saveValueBeforeAddingQuestions: 'Please save the company value before adding questions.',
    loading: 'Loading...',
    errorLoadingQuestions: 'Error loading questions.',
    noQuestionsYet: 'No questions yet.',
    addFirstQuestion: 'Add your first question to get started.',
    standardQuestionNotice:
        'You haven’t created a custom question for this company value. The standard question will therefore be used to evaluate it: “Do you feel <bold>{{firstNamePlaceholder}}</bold> demonstrates the <bold>{{name}}</bold> company value?”',
    fallbackQuestionInfo:
        'The fallback question is generated automatically during the assessment and cannot be edited here. If you add a custom question, the fallback will no longer be used.',
    firstNamePlaceholder: '[first name]',
    fallbackQuestionDefaultValueName: 'this company value',
    questions: 'Questions',
    addQuestion: 'Add Question',
    frozen: 'Frozen',
    delete: 'Delete',
    deactivate: 'Deactivate',
    activate: 'Activate',
    toggleStatusSuccess: '{{name}} has been {{action}}.',
    toggleStatusError: 'Failed to toggle value status.',
    deleteValueTitle: 'Delete the value "{{name}}"?',
    deleteValueMessage:
        'This action is irreversible. The value will be permanently deleted, along with all references to it in employee evaluations (scores and associated responses).',
    impactInformation: 'Impact Information',
    inProgressEvaluations: 'In-progress evaluations',
    employeesWithHistoricalData: 'Employees with historical data',
    associatedQuestions: 'Associated questions',
    deleteBlockedMessage:
        'Cannot delete this value because it is referenced by in-progress evaluations.',
    deleteError: 'Failed to delete company value.',
    questionTextPlaceholder: 'Enter your question...',
    multipleChoice: 'Multiple Choice',
    ratingScale: 'Rating Scale',
    yesNo: 'Yes/No',
    plainText: 'Plain Text',
    maxValue: 'Max Value',
    answerOptions: 'Answer Options',
    answerOptionsDescription: 'Options will be configured separately.',
    cannotDeleteFrozenQuestion:
        'Cannot delete a frozen question. This question is used in an active evaluation.',
    questionFrozenInfo:
        'This question is used in an active evaluation. Answer choices cannot be modified.',
    confirmDeleteQuestion: 'Are you sure you want to delete this question?',
    // Translations tab
    selectLanguage: 'Select Language',
    questionTexts: 'Question Texts',
    translationMissingFallback: 'Translation missing, will fall back to default language',
    missingTranslation: 'Missing translation',
    complete: 'Complete',
    incomplete: 'Incomplete',
    noAdditionalLanguages: 'No additional languages configured',
    addEvaluationLanguagesHint: 'Contact your administrator to add evaluation languages',
    nameMaxLength: 'Value name must not exceed {{max}} characters.',
    descriptionMaxLength: 'Description must not exceed {{max}} characters.',
    assessmentQuestions: 'Assessment questions',
    assessmentQuestionsDesc: 'Define the questions used to assess this value among employees.',
    evaluationQuestions: 'Evaluation questions',
};
